import React from 'react'

import { Container } from './styles'

interface IWarningCard {
    children: React.ReactNode;
    className?: string;
}

const WarningCard: React.FC<IWarningCard> = ({ children, className }) => (
    <Container className={className}>
        <h6>
            {children}
        </h6>
    </Container>
)


export default WarningCard